export const getMultiSocketName = (type: string, amount: number) => {
	switch (type) {
		case "object3d":
			return "Select all 3D objects";
		case "image":
			return `Select all ${amount} images`;
		default:
			return "Select all videos";
	}
};
